import { collection, doc, getDocs, getFirestore } from "firebase/firestore";
import { PageModuleDataWithPageId } from "../types";

export const getAllModulesByBrand = async (
  brandId: string,
): Promise<PageModuleDataWithPageId[]> => {
  const db = getFirestore();
  const brandDoc = doc(db, "brands", brandId);
  const pagesCollection = collection(brandDoc, "pages");
  const pagesSnapshot = await getDocs(pagesCollection);

  const modulePromises = pagesSnapshot.docs.map(async (pageDoc) => {
    const pageId = pageDoc.id;
    const modulesCollection = collection(brandDoc, "pages", pageId, "modules");
    const modulesSnapshot = await getDocs(modulesCollection);

    return modulesSnapshot.docs.map(
      (moduleDoc) =>
        ({
          id: moduleDoc.id,
          pageId,
          brandId,
          ...moduleDoc.data(),
        }) as PageModuleDataWithPageId,
    );
  });

  const modulesArrays = await Promise.all(modulePromises);

  return modulesArrays.flat();
};
